module.exports = __webpack_public_path__ + "img/logo.11a3921e.svg";